// reactstrap components
import { Container, Row, Col, Card} from "reactstrap";
import {useEffect, useMemo, useRef, useState} from "react";
import Brand from "../../../lib/Core/Backend/Controllers/Brand";
import Purchaser from "../../../lib/Core/Backend/Controllers/Purchaser";
import Catalogs from "lib/Core/Backend/Controllers/Catalogs";
import BrandCard from "../Cards/BrandCard";
import Select from "react-select";
import Notify from "lib/Utils/Alert";
import ReactNotificationAlert from "react-notification-alert";
import { Ellipsis } from "react-spinners-css";
import DownloadBrandsButton from "components/Button/DownloadBrandsButton";
import ModalDownloadFilePdfCsv from "components/Modal/DownloadFilePdfCsv";
import html2pdf from 'html2pdf.js';
import Utils from "lib/Utils/Utils";

const dollarUSLocale = Intl.NumberFormat('en-US', {
	style: "currency",
	currency: "USD",
});

const Header = (props) =>
{
	const token = props.token;
	const brandCtl = useMemo(() => new Brand(token), [token]);
	const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
	const catalogsCtl = useMemo(() => new Catalogs(token),[token]);

	const [brands, setBrands] = useState([]);
	const [filteredBrands, setFilteredBrands] = useState([]);

	const [brandOptions, setBrandOptions] = useState([]);
	const [currencyOptions, setCurrencyOptions] = useState([]);
	const [countryOptions, setCountryOptions] = useState([]);

	const [brandFilters, setBrandFilters] = useState([]);
	const [currencyFilters, setCurrencyFilters] = useState([]);
	const [countryFilters, setCountryFilters] = useState([]);

	const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false)
	const [fileData, setFileData] = useState([])

	const toggle = () => setIsDownloadModalOpen(!isDownloadModalOpen)

	const alert = useRef();
	const brandSelect = useRef();
	const countrySelect = useRef();
	const currencySelect = useRef();

	useEffect(() => {
		let brandsTemp = brands;
		if(brandFilters.length > 0){
			brandsTemp = brands.filter(brand => brandFilters.map(e => e.value).some(id => brand.id === id))
		}
		if(currencyFilters.length > 0){
			brandsTemp = brandsTemp.map(brand => {
				return {
					...brand,
					cards: brand.cards.filter(card => currencyFilters.map(e => e.value).some(currency => card.currency === currency))
				}
			})
		}
		if(countryFilters.length > 0){
			brandsTemp = brandsTemp.map(brand => {
				return {
					...brand,
					cards: brand.cards.filter(card => countryFilters.map(e => e.value).some(country => card.country.id === country))
				}
			})
		}
		setFilteredBrands(brandsTemp.sort((a, b) => a.name.localeCompare(b.name)))
	},[brandFilters, currencyFilters, countryFilters, brands])

	useEffect(() =>
	{
		catalogsCtl.countries(countriesData => {
			if(countriesData.error || countriesData.errorMessage){
				Notify(alert, 'danger', countriesData.errorMessage ?? countriesData.error)
			} else {
				if(props.id)		{
					purchaserCtl.activeBrands({
						"brandName": null,
						"countryId": null,
						"currencyId": null
					}, props.id, (data) =>
					{
						let brands = [];
						data.forEach(item =>
						{
							brands.push({
								name: item.name,
								id: item.id,
								purchaseFee: item.purchaseFee,
								purchaseDiscount: item.purchaseDiscount,
								cardCount: item.giftCardTypes.length,
								cards: item.giftCardTypes.map(card => (
									{
										...card,
										country: countriesData.find(country => country.id === card.countryId)
									}
								))
							});
						});
						setBrands(brands);
		
						setBrandOptions(
							brands.filter(brand => brand.cards.length > 0)
								.sort((a, b) => a.name.localeCompare(b.name))
									.map(brand => ({label: brand.name, value: brand.id}))
						)
		
						let cards = brands.map(brands => brands.cards).flat()

						setCurrencyOptions(cards.map(card => card.currency)
							.filter((currency, index, self) => self.indexOf(currency) === index)
								.sort((a, b) => a.localeCompare(b))
									.map(currency => ({label: currency, value: currency}))
						);

						setCountryOptions(cards.map(card => card.country)
							.filter((country, index, self) => self.indexOf(country) === index)
								.sort((a, b) => a.name.localeCompare(b.name))
									.map(country => ({label: country.name, value: country.id}))
						);
						
					});
				}
			}
		})		

		
	}, [token, props.id, catalogsCtl, purchaserCtl])

	useEffect(() => {
		if (!props.id)
			return
		purchaserCtl.availableBrands(props.id, (data) => {
			if(data && !data.error){
				const _brands = []
				purchaserCtl.getAllBrandsLimits(props.id, dat => {
					const brandsLimits = dat
					brandsLimits && brandsLimits.map((i) => ({
						id: i.id,
						brandName: data.brandList[i.brandId],
						brandId: i.brandId,
						purchaserFee: i.purchaseFee,
						purchaserDiscount: i.purchaseDiscount,
						orderThreshold: i.orderThreshold
					}))
					purchaserCtl.activeCards(props.id, cardData => {
						if (!cardData || cardData.error)
							return
						const feeDiscountInformationByBrandId = data.brands.reduce((accumulator, current) => ({ ...accumulator, [current.id]: current }), {})
						Object.keys(data.brandList).forEach((brandId, idx ) => {
							_brands.push(
								{
									id: brandId,
									name: data.brandList[brandId],
									purchaseFee: data.purchaserDetail.id === brandId ? data.purchaserDetail.purchaseFee : feeDiscountInformationByBrandId[brandId].purchaseFee,
									purchaseDiscount: data.purchaserDetail.id === brandId ? data.purchaserDetail.purchaseDiscount : feeDiscountInformationByBrandId[brandId].purchaseDiscount,
									// logo: brandLogos.find(logo => logo.id === parseInt(brandId)).logo || 'Not Found',
									cards: cardData.filter(card => card.brandId === parseInt(brandId)),
								}
							)
						})
						const newBrands = _brands.map((e) => {
							for(let val of brandsLimits || []){
								if(e.id === val.brandId){
									e.purchaseDiscount = val.purchaserDiscount;
									e.purchaseFee = val.purchaserFee
								}
							}
							return e
						})
						setFileData(newBrands)
					})
				})
			}
		})
	}, [props.id])

	const createTable = (data) => {
    let tbl = document.createElement("table");
		let tblHead = document.createElement('thead');
    let tblPurchaserHead = document.createElement('thead');
  	let tblBody = document.createElement("tbody");

		tbl.classList.add('table', 'table-bordered');
		tblHead.classList.add('thead-dark');
    tblPurchaserHead.classList.add('thead-dark');

		let headers = document.createElement('tr');
		let headerLabels = [
      `<div class= 'row'>
        <div class= 'col-4'>Brands</div>
        <div class= 'col-4'>Discount</div>
        <div class= 'col-4'>Fee</div>
      </div>`,
      'Card Types'];
		headerLabels.forEach(header => {
			let cell = document.createElement('th');
			cell.innerHTML = header;
			headers.appendChild(cell);

		});

    data.sort((a, b) => {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    }).forEach((brand, brandIdx) => {
      let brandRow = document.createElement('tr');
      let brandName = document.createElement('th');
      brandName.setAttribute('rowspan', `${brand.cards.length === 0 ? 1 : brand.cards.length}`);
      brandName.setAttribute('scope', 'row');
      if(brandIdx % 2 === 0){
        brandName.classList.add('table-secondary');
      } else{
        brandName.classList.add('table-light')
      }
      brandName.innerHTML = `<div class= 'row' >
        <div class= 'col-4' style='white-space:initial;margin:0 auto;'>${brand.name}</div> 
        <div class= 'col-4'>${Utils.percentFormat(brand.purchaseDiscount/100)}</div>
        <div class= 'col-4'>${dollarUSLocale.format(brand.purchaseFee)}</div>
      </div>`;
      brandRow.appendChild(brandName);
      if(brand.cards.length === 0){
        let cardCell = document.createElement('td');
        cardCell.innerHTML = '';
        if(brandIdx % 2 === 0){
          cardCell.classList.add('table-secondary');
        } else{
          cardCell.classList.add('table-light')
        }
        brandRow.appendChild(cardCell);
        tblBody.appendChild(brandRow);
      } else {
        brand.cards.forEach((card, cardIdx) => {
          let cardCell;
          if(cardIdx === 0){
            cardCell = document.createElement('td');
            cardCell.innerHTML = `${card.productName} (${card.currency})`;
            brandRow.appendChild(cardCell);
            tblBody.appendChild(brandRow);
          } else {
            let row = document.createElement('tr');
            cardCell = document.createElement('td');
            cardCell.innerHTML = `${card.productName} (${card.currency})`;
            row.appendChild(cardCell);
            tblBody.appendChild(row);
          }
          if(brandIdx % 2 === 0){
            cardCell.classList.add('table-secondary');
          } else{
            cardCell.classList.add('table-light')
          }
        });
      }
      
    });

		tblHead.appendChild(headers);
    tbl.appendChild(tblPurchaserHead);
		tbl.appendChild(tblHead)
		tbl.appendChild(tblBody);
		return tbl;
  }

	const downloadPdf = () => {
    // let pdf = createTable(fileData);
	let pdf = createTable(filteredBrands);
    var opt = {
      margin: [24, 15, 24, 15],
      filename: `Available brands for Purchaser.pdf`,
			image: {type: 'jpg', quality: 0.98},
			html2canvas: {scale: 2, logging: true, dpi: 192, letterRendering: true },
			jsPDF: {unit: 'mm', format: 'letter', orientation: 'portrait'},
			pagebreak: { mode: ['css'] }
    };
    html2pdf(pdf, opt)
  }

  const downloadCsvFile = () => {
    let data = fileData.sort((a, b) => {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

    let csv = [];
    filteredBrands.forEach(brand => {
		    if(brand.cards.length > 0){
        brand.cards.forEach(card => {
          csv.push(`"${brand.name}","${card.productName}",${card.currency ?? 'N.A.'},${Utils.percentFormat(brand.purchaseDiscount/100)},${dollarUSLocale.format(brand.purchaseFee)}`)
        })
      } else {
        csv.push(`${brand.name},No cards Available,,${Utils.percentFormat(brand.purchaseDiscount/100)},${dollarUSLocale.format(brand.purchaseFee)}`)
      }
    })

    csv = `Brand, Gift Card Type, Currency, Discount, Fee\n${csv.join('\n')}`
    csv = `AvailableBrandsForPurchaser\n\n ${csv}`;

    const element = document.createElement("a");
		const file = new Blob([csv], {type: 'text/plain'});
		element.href = URL.createObjectURL(file);
		element.download = `Available brands for Purchaser.csv`;
		document.body.appendChild(element); // Required for this to work in FireFox
		element.click();
  }

	return (
		<>
			<ReactNotificationAlert ref={alert} />
			<ModalDownloadFilePdfCsv isOpen={isDownloadModalOpen} toggle={toggle} downloadPdf={downloadPdf} downloadCsvFile={downloadCsvFile}/>
			<div className="header bg-gradient-warning pb-8 pt-5 pt-md-8">
				<div style={{ display: 'flex' }}>
					<div style={{ flex: 1 }} />
					<div style={{ flex: 1, textAlign: 'center' }}>
						<h1 className="font-weight-bold text-xl-center" style={{
							fontSize: "40px", marginBottom: "25px", color: "#efefef", textShadow: "3px 2px 4px #00000055",
						}}>
							Available Brands
						</h1>
					</div>
					<div style={{ flex: 1, textAlign:"end", paddingRight: '39px' }}>
						<DownloadBrandsButton onClick={toggle} />
					</div>
				</div>
				<hr style={{width: "75%", borderWidth: "2px", boxShadow: "2px 2px 5px #cd222255"}}/>
				<Container fluid>
					<div className="header-body">
						<Row className="mb-3">
							<Col>
								<Select
									name="brand"
									placeholder="Select a brand..."
									isMulti={true}
									options={brandOptions}
									onChange={e => setBrandFilters(e)}
									ref={brandSelect}
								/>
							</Col>
							<Col>
								<Select
									name="country"
									placeholder="Select a country..."
									isMulti={true}
									options={countryOptions}
									onChange={e => setCountryFilters(e)}
									ref={countrySelect}
								/>
							</Col>
							<Col>
								<Select
									name="currency"
									placeholder="Select a currency..."
									isMulti={true}
									options={currencyOptions}
									onChange={e => setCurrencyFilters(e)}
									ref={currencySelect}
								/>
							</Col>
						</Row>
						<Row>
							{filteredBrands.length > 0 ?

								filteredBrands.map((brand) =>
									{
										if(brand.cards.length <= 0){
											return null
										}
										return (
											<Col key={brand.id} md={4} style={{minHeight: "240px"}}>
												<BrandCard 
													token={token}
													brandName={brand.name}
													discount={brand.purchaseDiscount}
													fee={brand.purchaseFee}
													logoURL={brandCtl.logo(brand.name)}
													cards={brand.cards}
													cardTypeNum={brand.cards.length}
												/>
											</Col>
										);
									}
								)

								: (
									<>
										<Col md={4} style={{minHeight: "240px"}}>
											<Card>
												<Row className="justify-content-center">
													<Ellipsis color="#73797d" />
												</Row>
												
											</Card>
										</Col>
										<Col md={4} style={{minHeight: "240px"}}>
											<Card>
												<Row className="justify-content-center">
													<Ellipsis color="#73797d" />
												</Row>
												
											</Card>
										</Col>
										<Col md={4} style={{minHeight: "240px"}}>
											<Card>
												<Row className="justify-content-center">
													<Ellipsis color="#73797d" />
												</Row>
												
											</Card>
										</Col>
									</>
									
								)
						
							}
						</Row>
					</div>
				</Container>
			</div>
		</>
	);
};

export default Header;
